import React from 'react';
import { useSelector } from 'react-redux';
import { NavLink, Redirect, Route, Switch } from 'react-router-dom';
import WithNavigation from 'src/layouts/WithNavigation/WithNavigation';
import { PATHS } from 'src/common/constants';
import { USER_ROLE_NAMES } from 'src/pages/Settings/types';
import CalendarView from 'src/pages/Calendar/CalendarView';
import CalcomIntegrationTab from 'src/pages/Calendar/CalcomIntegration/CalcomIntegrationTab';
import calcomLogo from 'src/pages/Calendar/CalcomIntegration/calcom-logo.svg';
import './calendar-tabs.scss';

const ALLOWED_CALCOM_ROLES: string[] = [
  USER_ROLE_NAMES.ADMIN,
  USER_ROLE_NAMES.SUPER_ADMIN,
  USER_ROLE_NAMES.PROPERTY_DEVELOPER,
];

export const CalendarComponent = () => {
  const userRoleName: string | undefined = useSelector(
    (state: any) => state.auth?.user?.roles?.[0]?.role?.name
  );

  const canManageCalcom: boolean =
    userRoleName !== undefined && ALLOWED_CALCOM_ROLES.includes(userRoleName);

  return (
    <WithNavigation
      title="Calendar"
      top={
        <nav className="calendar-tabs">
          <NavLink
            exact
            to={PATHS.CALENDAR}
            className="calendar-tab"
            activeClassName="active"
          >
            Juniper Calendar
          </NavLink>
          {canManageCalcom && (
            <NavLink
              to={PATHS.CALENDAR_CALCOM}
              className="calendar-tab"
              activeClassName="active"
            >
              <img src={calcomLogo} className="calendar-tab-logo" alt="Cal.com" />
              <span className="calendar-tab-label">integrations</span>
            </NavLink>
          )}
        </nav>
      }
    >
      <Switch>
        <Route exact path={PATHS.CALENDAR} component={CalendarView} />
        {canManageCalcom && (
          <Route path={PATHS.CALENDAR_CALCOM} component={CalcomIntegrationTab} />
        )}
        {/* Service Providers deep-linking to the Cal.com tab land back on the calendar. */}
        <Redirect to={PATHS.CALENDAR} />
      </Switch>
    </WithNavigation>
  );
};

export default CalendarComponent;